import { render, staticRenderFns } from "./UmDb.vue?vue&type=template&id=4a242c45&"
import script from "./UmDb.vue?vue&type=script&lang=js&"
export * from "./UmDb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports